import { createContext } from 'react';

interface DatePickerContextProps {
  focusedDate: Date | null;
  isDateFocused: (date: Date) => boolean;
  isDateSelected: (date: Date) => boolean;
  isDateHovered: (date: Date) => boolean;
  isDateBlocked: (date: Date) => boolean;
  isFirstOrLastSelectedDate: (date: Date) => boolean;
  onDateFocus: (date: Date) => void;
  onDateHover: (date: Date) => void;
  onDateSelect: (date: Date) => void;
}

const DatePickerContext: DatePickerContextProps = {
  focusedDate: null,
  isDateFocused: (date: Date) => !date,
  isDateSelected: (date: Date) => !date,
  isDateHovered: (date: Date) => !date,
  isDateBlocked: (date: Date) => !date,
  isFirstOrLastSelectedDate: (date: Date) => !date,
  onDateFocus: (date: Date) => date,
  onDateHover: (date: Date) => date,
  onDateSelect: (date: Date) => date,
};

export default createContext(DatePickerContext);
